function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`bg-gray-200 animate-pulse rounded ${className}`} />
}

/* ── Hero Skeleton ── */
export function HeroSkeleton() {
  return (
    <div className="relative w-full h-[400px] md:h-[500px] bg-gray-200 animate-pulse">
      <div className="h-full max-w-[1024px] mx-auto px-4 flex flex-col justify-center gap-4">
        <Skeleton className="h-10 w-[400px] max-w-full rounded-lg" />
        <Skeleton className="h-5 w-[300px] max-w-full rounded-lg" />
        <Skeleton className="h-12 w-[160px] rounded-full mt-2" />
      </div>
    </div>
  )
}

/* ── Featured Card Skeleton ── */
export function FeaturedCardSkeleton() {
  return (
    <div className="bg-white border border-gray-200 rounded-3xl overflow-hidden flex flex-col flex-1 min-w-0">
      <Skeleton className="h-[246px] rounded-none" />
      <div className="p-6 flex flex-col gap-3">
        <Skeleton className="h-5 w-3/4" />
        <Skeleton className="h-3 w-1/2" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-2/3" />
        <hr className="border-gray-200" />
        <Skeleton className="h-10 w-full rounded-full" />
      </div>
    </div>
  )
}

/* ── Course Card Skeleton ── */
export function CourseCardSkeleton() {
  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-hidden flex flex-col">
      <Skeleton className="h-[170px] rounded-none" />
      <div className="p-3 flex flex-col gap-3">
        <Skeleton className="h-5 w-4/5" />
        <Skeleton className="h-5 w-1/3" />
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-14" />
        </div>
        <hr className="border-gray-200" />
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-16" />
        </div>
      </div>
    </div>
  )
}

/* ── Video Card Skeleton ── */
export function VideoCardSkeleton() {
  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-hidden flex flex-col">
      <Skeleton className="h-[170px] rounded-none" />
      <div className="p-3">
        <Skeleton className="h-4 w-4/5" />
        <Skeleton className="h-4 w-1/2 mt-2" />
      </div>
    </div>
  )
}

/* ── Teacher Card Skeleton ── */
export function TeacherCardSkeleton() {
  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-hidden flex flex-col">
      <Skeleton className="h-[170px] rounded-none" />
      <div className="px-3 pb-3 pt-2 flex flex-col gap-3">
        <div>
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-3 w-1/2 mt-1" />
        </div>
        <hr className="border-gray-200" />
        <div className="flex items-center text-center">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex-1 flex flex-col items-center gap-1">
              <Skeleton className="h-5 w-8" />
              <Skeleton className="h-3 w-10" />
            </div>
          ))}
        </div>
        <hr className="border-gray-200" />
        <Skeleton className="h-10 w-full rounded-full" />
      </div>
    </div>
  )
}

/* ── Post Card Skeleton ── */
export function PostCardSkeleton() {
  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-hidden w-[282px] shrink-0 flex flex-col">
      <Skeleton className="h-[170px] rounded-none" />
      <div className="p-3 flex flex-col gap-3">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-[38px] w-full" />
        <hr className="border-gray-200" />
        <div className="flex gap-3">
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-4 w-12" />
          <Skeleton className="h-4 w-12" />
        </div>
      </div>
    </div>
  )
}

export default Skeleton
